import { render, staticRenderFns } from "./remake.vue?vue&type=template&id=74444154&scoped=true"
import script from "./remake.vue?vue&type=script&lang=js"
export * from "./remake.vue?vue&type=script&lang=js"
import style0 from "./remake.vue?vue&type=style&index=0&id=74444154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74444154",
  null
  
)

export default component.exports